/** Stacking order for app modals; field dropdowns portaled inside must sit above this. */
export var MODAL_Z_INDEX = 1200;